import parseUri               from './parseURI'
import getSportFromRoot       from './getSportFromRoot'
/*
 * These are the default react pages that are currently available, setting to false
 * here will stop that page type from being recognised as a react page and will stop
 * the links from working.
 * NOTE: this can be overridden on a per edition basis by adding
 * a key to the config called `reactOverride` and following the sport -> pageType structure
 * the editions boolean value will always take precedent over the values set here...
 */
const REACT_PAGE_TYPES = {
  'cricket' : {
    'table' : true,
    'scores' : true,
    'statistics' : true,
    'report' : true,
    'preview' : true,
    'game' : true,
    'scorecard' : true,
    'commentary' : true,
    'coverage' : true,
    'video' : true,
    'static' : true,
    'hawkeye' : true
  },
  'rugby' : {
    'table' : true,
    'fixtures' : true,
    'schedule' : true,
    'report' : true,
    'preview' : true,
    'match' : true,
    'game' : true,
    'playerstats' : true,
    'matchstats' : true,
    'commentary' : true,
    'lineups' : true,
    'conversation' : true,
    'scores' : true,
    'scoreboard' : true,
    'results' : true,
    'team' : true
  },
  'rugby-league' : {
    'table' : true,
    'fixtures' : true,
    'schedule' : true,
    'preview' : true,
    'match' : true,
    'game' : true,
    'playerstats' : true,
    'matchstats' : true,
    'commentary' : true,
    'lineups' : true,
    'conversation' : true,
    'scores' : true,
    'scoreboard' : true,
    'results' : true
  },
  'soccer' : {
    'table' : false,
    'schedule' : false
  }
}

/**
 * NOTE: this assumes the domain will not change and will not jump editions. i.e. going
 * from espn.com/rugby/tables to espn.co.uk/rugby/tables will be seen as an external link
 * and therfore not be dealt with by react-router
**/

export default function isReactPath( hostname = '', URI = '', edition = {}) {

  if ( typeof URI === 'string' && typeof hostname === 'string' ) {
    const reactPages    = edition.reactOverride || {}
    const parsedURI     = parseUri( URI ) || {}
    const hostReplaces  = /localhost|local\.|www\.|-qa|qa\.|preview\./
    //console.info('edition', edition)
    //console.info('parseURI', parsedURI)
    /* default if relative or localhost */
    if ( parsedURI.host === 'localhost' || parsedURI.host === '' ) {
      parsedURI.host = edition.domain
    }

    const simpleHost      = (parsedURI.host || '').replace( hostReplaces, '' ) || ''
    const editionHost     = (edition.domain || '').replace( hostReplaces, '' ) || ''
    //console.info('simpleHost, editionHost', simpleHost, editionHost)
    /* Validate the domain */
    if ( simpleHost === editionHost ) {
      let uriPath = parsedURI.path || ''
      if ( uriPath ) {
        // prepend `/` separator if the uripath starts with no `/`
        if ((/^\//).test(uriPath) === false ) {
          uriPath = '/' + uriPath
        }
        // prepend `edition.defaultSport` if edition is not multi-sports
        let hasSport = new RegExp('^\/'+edition.defaultSport)
        if (edition.isMultiSports === false && hasSport.test(uriPath) === false) {
          uriPath = edition.defaultSport + uriPath
        }
        const sport       = pathToSport( uriPath ) || ''
        const pageType    = pathToPageType( uriPath ) || ''
        const configTypes = reactPages[ sport ] || {}
        const availTypes  = REACT_PAGE_TYPES[ sport ] || {}
        const mergedTypes = {}
        Object.assign( mergedTypes, availTypes, configTypes )
        if ( mergedTypes[ pageType ] ) {
          return true
        }
      }
    }
  }
  return false
}

function splitURI( uriPath ) {

  uriPath = uriPath.replace( /^\//, '' )
  const pathSections = uriPath.split('/') || []
  return pathSections

}

function pathToSport( uriPath ) {

  const pathSections = splitURI( uriPath ) || []
  return getSportFromRoot( pathSections[0] ) || ''

}

function pathToPageType( uriPath ) {

  const pathSections = splitURI( uriPath ) || []
  const sport = pathToSport( uriPath ) || ''

  if ( sport === 'cricket' && pathSections[1] === 'series' && pathSections[2] !== '_' ) {
    return pathSections[3]
  }

  return pathSections[1]

}



// WEBPACK FOOTER //
// ../app/lib/utils/isReactPath.js